(function ($) {
    new Vue({
        el: '#sidebarBox',
        data: {
            // 顶部图片
            topImgUrl: '',
            // 功能列表
            itemList: [],
            // 列表是否展开
            isShowList: true,
            // 联系我们弹窗是否显示
            isShowContact: false,
            // 小程序二维码是否显示
            isShowQrCode: false,

            // 是否显示滚动到顶部按钮
            isShowToTop: false,

            // 是否是会场页面
            isMeeting: window.location.href.indexOf('meeting/live.html') > -1
        },
        mounted: function () {

            var _this = this;
            // 点击其他地方隐藏弹窗
            document.addEventListener('click', function (e) {
                _this.hideAllDialog();
            });

            // 滚动时隐藏弹窗
            window.addEventListener('scroll', function (e) {
                _this.hideAllDialog();

                // 如果不在页面顶部则显示滚动到顶部按钮
                _this.isShowToTop = document.documentElement.scrollTop !== 0;
            });

            this.getSidebarData();

            // 如何是会场页面自动收起侧边栏
            if (this.isMeeting) {
                this.toggleSidebar();
            }
        },
        methods: {

            // 隐藏所有弹窗
            hideAllDialog: function () {
                this.isShowContact = false;
                this.isShowQrCode = false;
            },

            // 获取侧边栏数据
            getSidebarData: function () {
                var _this = this;
                var info = {
                    platform : 'normal',
                    type : common.isM? 'wap': 'pc'
                }
                common.getJson(solution_host + '/api/shop/sidebar', info, function (res) {
                    console.log(res);
                    _this.topImgUrl = res.data.img
                    _this.itemList = res.data.items
                });
            },
            // 右侧浮窗Topkv
            sidebarHeaderClick: function () {
                gioTrackAction.redPacketRainTopkv();
                window.open(window.solution_host + '/campaign/promotion');
            },

            // 点击
            itemClick: function (item) {
                userAction.navView(item.title);
                switch (item.custom) {
                    case 'url':
                        if (item.tag) {
                            gioTrackAction.gio_base(item.tag);
                        }
                        common.gotoUrl(item.url);
                        break;
                    case 'contact':
                        this.isShowQrCode = false;
                        this.isShowContact = !this.isShowContact;
                        break;
                    case 'qrcode':
                        this.isShowContact = false;
                        this.isShowQrCode = !this.isShowQrCode;
                        break;
                    default:
                        break;
                }
            },

            // 侧边栏显示和收起
            toggleSidebar: function () {
                this.isShowList = !this.isShowList;
                $('.sidebar-content').slideToggle();

                //
            },

            // 滚动到顶部
            toTop: function () {
                $('html, body').animate({scrollTop: 0}, 'fast');
            },

            // 隐藏侧边栏
            closeSidebar: function () {
                $("#sidebarBox").hide();
            },
        }
    });
}(jQuery));
